<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="leads-edit-popup">
        <ValidationObserver ref="form" class="centerx default-input" v-slot="{handleSubmit}">
            <div class="vx-row mb-8">
                <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider vid="first_name" :name="$t('modals.First_name')" rules="required|minmax:1,50" v-slot="{ errors }">
                        <vs-input
                            :placeholder="$t('modals.First_name')"
                            class="w-full"
                            v-bind="$iconData('icon-user', 'fi-rr-user')"
                            label-placeholder="icon-no-border"
                            v-model="leadData.first_name"
                        />
                        <span class="text-danger text-xs" >{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider vid="last_name" :name="$t('modals.Last_name')" rules="required|minmax:1,50" v-slot="{ errors }">
                        <vs-input
                            :placeholder="$t('modals.Last_name')"
                            class="w-full"
                            v-bind="$iconData('icon-user', 'fi-rr-user')"
                            label-placeholder="icon-no-border"
                            v-model="leadData.last_name"
                        />
                        <span class="text-danger text-xs" >{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>

            <div class="vx-row mb-8">
                <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider vid="phone" :name="$t('modals.Phone')" rules="required|numeric|minmax:8,15" v-slot="{ errors }">
                        <vs-input
                            :placeholder="$t('modals.Phone')"
                            class="w-full"
                            v-bind="$iconData('icon-phone', 'fi-rr-mobile-notch')"
                            label-placeholder="icon-no-border"
                            v-model="leadData.phone"
                        />
                        <span class="text-danger text-xs" >{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider vid="ip" :name="$t('modals.IP')" rules="required|ip" v-slot="{ errors }">
                        <vs-input
                            :placeholder="$t('modals.IP')"
                            class="w-full"
                            v-bind="$iconData('icon-crosshair', 'fi-rr-location-crosshairs')"
                            label-placeholder="icon-no-border"
                            v-model="leadData.ip"
                        />
                        <span class="text-danger text-xs" >{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>

            <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-col w-full" style="margin-top: -20px">
                        <ValidationProvider vid="language" :name="$t('global.Language')" rules="required" v-slot="{ errors }">
                            <label class="text-xs opacity-75">{{ $t('global.Language') }}</label>
                            <v-select
                                :options="options.languages"
                                v-model="leadData.language"
                                name="language"
                                :clearable="false"
                                class="mb-4 sm:mb-0 cursor-pointer"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <ValidationProvider vid="email" :name="$t('global.Email')" rules="required|email|max:50" v-slot="{ errors }">
                        <vs-input
                            :placeholder="$t('global.Email')"
                            class="w-full"
                            v-bind="$iconData('icon-mail', 'fi-rr-envelope')"
                            label-placeholder="icon-no-border"
                            v-model.trim="leadData.email"
                        />
                        <span class="text-danger text-xs" >{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                </div>
            </div>

            <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-col w-full">
                        <ValidationProvider vid="landing_name" :name="$t('global.Landing')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{ $t('global.Landing') }}</label>
                            <v-select
                                :options="options.landings"
                                :reduce="landing => landing.landing_name"
                                v-model="leadData.landing_name"
                                label="landing_name"
                                :clearable="false"
                                class="mb-4 sm:mb-0 cursor-pointer"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-col w-full mt-6">
                        <vs-input
                            :placeholder="$t('global.landing_url')"
                            class="w-full"
                            v-bind="$iconData('icon-link', 'fi-rr-link-alt')"
                            label-placeholder="icon-no-border"
                            v-model="leadData.landing_url"
                        />
                    </div>
                </div>
            </div>

            <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full" v-if="leadData.campaign_identifier">
                    <div class="vx-col w-full">
                        <ValidationProvider vid="campaign_identifier" :name="$t('modals.Campaign_identifier')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{ $t('modals.Campaign_identifier') }}</label>
                            <v-select
                                :options="options.campaigns"
                                v-model="leadData.campaign_identifier"
                                :clearable="false"
                                class="sm:mb-0 cursor-pointer"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-col w-full">
                        <ValidationProvider vid="affiliate_hash" :name="$t('global.Affiliate')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{ $t('global.Affiliate') }}</label>
                            <v-select
                                :options="options.users"
                                :reduce="user => user.affiliate_hash"
                                v-model="leadData.affiliate_hash"
                                label="name"
                                :clearable="false"
                                class="mb-4 sm:mb-0 cursor-pointer"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-col w-full">
                        <label class="text-sm opacity-75">{{ $t('label.Postbacks') }}</label>
                        <v-select
                            :options="options.postbacks"
                            :reduce="postback => postback.id"
                            v-model="leadData.tracker_callback_ids"
                            label="name"
                            multiple
                            :clearable="false"
                            class="mb-4 sm:mb-0 cursor-pointer"
                            :closeOnSelect="false"
                        />
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-col w-full">
                        <label class="text-sm opacity-75">{{ $t('label.Advertisers_history') }}</label>
                        <v-select
                            :options="options.advertisers"
                            :reduce="advertiser => advertiser.name"
                            v-model="leadData.advertisers_history"
                            label="name"
                            multiple
                            :closeOnSelect="false"
                            :clearable="false"
                            class="mb-4 sm:mb-0 cursor-pointer"
                        />
                    </div>
                </div>
            </div>
            <vs-divider/>
            <div class="vx-row mb-4">
                <div v-for="sub in arraySubs" :key="sub" class="vx-col sm:w-1/3 w-full mb-3">
                    <div class="vx-col w-full mt-5">
                        <vs-input
                            :label-placeholder="$t(`statistic_fields.${sub}`)"
                            class="w-full"
                            v-model="leadData[sub]"
                           />
                    </div>
                </div>
            </div>
            <vs-divider/>
            <div class="vx-row mb-4">
                <div class="vx-col sm:w-1/4 w-full">
                    <div class="vx-col w-full mt-6">
                        <ValidationProvider vid="external_price" :name="$t('label.External_price')" rules="required|checkNumberOrNonInteger" v-slot="{ errors }">
                            <vs-input
                                :label-placeholder="$t(`label.External_price`)"
                                class="w-full"
                                v-model="leadData.external_price"
                                disabled
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                    <div class="vx-col w-full mt-6">
                        <ValidationProvider vid="internal_price" :name="$t('label.Internal_price')" rules="required|checkNumberOrNonInteger" v-slot="{ errors }">
                            <vs-input
                                :label-placeholder="$t(`label.Internal_price`)"
                                class="w-full"
                                v-model="leadData.internal_price"
                                disabled
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                    <div class="vx-col w-full mt-6">
                        <ValidationProvider vid="percent" :name="$t('label.percent')" rules="required|floatOrInteger|max_value:100" v-slot="{ errors }">
                            <vs-input
                                :label-placeholder="$t(`label.percent`)"
                                class="w-full"
                                v-model="leadData.percent"
                                disabled
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                    <div class="vx-col w-full">
                        <label class="text-sm opacity-75">{{ $t('label.guarantee') }}</label>
                        <vs-switch disabled color="success" v-model="leadData.guarantee"
                                   icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-check" class="mt-2"/>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full ml-auto text-right">
                    <div class="mt-8 flex flex-wrap items-center justify-end">
                        <vs-button class="mr-3 mb-2" @click.prevent="handleSubmit(checkForm)">{{ $t('global.Save') }}</vs-button>
                    </div>
                </div>
            </div>
        </ValidationObserver>

        <!-- Save & Reset Button -->

    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

import EventBus from '@/store/eventBus'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import {utils} from '@/utils/mixins'

export default {
    components: {
        vSelect,
        ValidationProvider,
        ValidationObserver
    },

    props: ['popupData', 'popupType', 'popupButton'],

    mixins: [utils],

    data() {
        return {
            options: {
                offers: [],
                landings: [],
                languages: [],
                affiliate: []
            },
            leadData: {},
            additionalData: {},
            arraySubs: ['sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'sub6', 'sub7', 'sub8', 'sub9']
        }
    },

    methods: {
        async checkForm() {
            try {
                const valid = this.$refs.form.validate()
                if(valid) {
                    await this.submitForm()
                }
            } catch(e) {
                new ErrorHandler(e).send
            }
        },

        isObject(value) {
            return typeof value === "object" && value !== null && value !== undefined && !Array.isArray(value);
        },

        async submitForm() {
            const data = {...this.leadData}

            if (this.leadData.campaign_identifier && this.leadData.campaign_identifier.value) {
                data.campaign_identifier = this.leadData.campaign_identifier.value
            }

            data.guarantee = data.guarantee ? 1 : 0

            Object.keys(data).map(key => {
                if (typeof data[key] === 'string') data[key] = data[key].trim()
            })

            this.arraySubs.forEach(sub => {
                if(!data[sub]) {
                    data[sub] = null
                }
            })

            data.guarantee = data.guarantee ? 1 : 0

            try {
                const response = await send(`${this.$url.statistic.lead_update}${this.leadData.id}/update`, 'PUT', {data}).then(response => response.data.result)

                EventBus.$emit('updateLeads', response.lead)
                EventBus.$emit('emitPopupEvent', {type: 'close'})

            } catch (error) {
                if (error.response) {
                    const response = error.response.data.result.errors
                    if (response && this.isObject(response)) {
                        this.$refs.form.setErrors(this.$errors(response))
                    }
                }
                new ErrorHandler(error).send
            }

        },

        setAffiliate(affiliate){
            this.leadData.affiliate_hash = affiliate
            this.options.users = this.options.teams.find(team => team.id === this.leadData.team_id).users
        },

    },
    async mounted() {
        try {
            if(this.popupType === 'editLead') {
                const leadData = await send(this.$url.statistic.get_lead_statistic + `/${this.popupData}`, 'GET').then(data => data.data.result)

                leadData.lead.advertisers_history = (leadData.lead.advertisers_history || []).map(item => item.toString())

                this.leadData = {...leadData.lead}

                const filters = {...leadData.filters}

                filters.languages = [...new Set([...filters.languages])]

                filters.campaigns = filters.campaigns.map(item => ({
                    label: item.name,
                    value:item.campaign_identifier
                }))

                filters.advertisers = this.createNameById(filters.advertisers)

                this.options = {...filters}

                this.leadData.campaign_identifier = this.options.campaigns.find(item => item.value === this.leadData.campaign_identifier)

                this.arraySubs.forEach(sub => {
                    if (!this.leadData[sub]){
                        this.leadData[sub] = ''
                    }
                })

                this.leadData.tracker_callback_ids = this.leadData.tracker_callback_ids ? this.leadData.tracker_callback_ids.map(tracker => Number(tracker)) : null
            }

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch(e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.error {
    input {
        border: 1px solid red !important;
    }
}
</style>
